/**
 * Fetches data from a given path using the Fetch API.
 * @param path - The URL path to fetch data from.
 * @param options - Optional request options to customize the fetch request.
 *
 * @link https://nextjs.org/docs/app/guides/caching
 * @link https://nextjs.org/docs/app/api-reference/functions/fetch
 */
export const fetchData = async (path: string, options?: RequestInit): Promise<any> => {
  const response = await fetch(path, options)
  if (response.ok) {
    return response.json()
  } else {
    return undefined
  }
}

/**
 * Fetches data from a given path, prepending the base URL if on the server.
 * @param url - The URL to fetch data from.
 * @param options - Optional request options to customize the fetch request.
 * @returns A promise that resolves to the fetched data.
 *
 * @link https://nextjs.org/docs/app/api-reference/functions/fetch
 */
export const fetch = async (url: string, options: RequestInit = {}): Promise<any> => {
  const finalOptions = {
    ...options,
    cache: 'no-cache',
    keepalive: false,
    next: {
      revalidate: 0,
    },
  } as RequestInit

  return globalThis.fetch(url, finalOptions)
}
